import React from 'react';
import ArticleHeroImageRight from 'components/Sections/Banners/ArticleHero/ArticleHeroImageRight/ArticleHeroImageRight';
import { usePageData } from 'lib/page-data/PageDataContext';
import { ComponentProps } from 'lib/component-props';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import { useCalculatedArticleFields } from 'hooks/useCalculatedArticleField';
import { useI18n } from 'next-localization';

const ArticleHero: React.FC<ComponentProps> = ({ rendering }) => {
  const { articleData } = usePageData('article') ?? {};
  const { sitecoreContext } = useSitecoreContext();
  const { getArticleType } = useCalculatedArticleFields();
  const { t } = useI18n();

  const articleType = articleData?.template
    ? getArticleType(articleData?.template)?.charAt(0).toUpperCase() +
      getArticleType(articleData?.template)?.slice(1)
    : t('article');

  const tagValues = {
    firstTag: articleType,
    secondTag: articleData?.articleCategory?.targetItem?.name?.value,
  };

  return articleData ? (
    <ArticleHeroImageRight
      data-e2e-component-uid={rendering.uid}
      article={articleData}
      tagValues={tagValues}
    />
  ) : sitecoreContext.pageEditing ? (
    <EEPlaceholder>Article Hero</EEPlaceholder>
  ) : null;
};

export default ArticleHero;
